export enum AuditLogOperationEnum {
    INSERT = 'I',
    UPDATE = 'U',
    DELETE = 'D',
}

export const AuditLogOperationMap = new Map<AuditLogOperationEnum, string>();
AuditLogOperationMap.set(AuditLogOperationEnum.INSERT, 'INSERT');
AuditLogOperationMap.set(AuditLogOperationEnum.UPDATE, 'UPDATE');
AuditLogOperationMap.set(AuditLogOperationEnum.DELETE, 'DELETE');